import * as m from 'mithril';
import * as dayjs from 'dayjs';
import './DateSwitcher.css';
import SearchCriteria from '../models/SearchCriteria';
import e = require('express');
import CustomSvgIcon from './CustomSvgIcon';

interface Attrs {
    searchCriteria: SearchCriteria,
    maximumDays?: number,
    searchDate: string,
    onDateChange: (searchCritiera: SearchCriteria) => void,
}

function DateSwitcher(): m.Component<Attrs> {
    let showDateList: string[] = [];
    let previousBtnActiveStatus = true;
    let nextBtnActiveStatus = true;

    function scrollLeft() {
        var ele = document.getElementById("scrollContainter");

        if (ele) {
            ele.style.scrollBehavior = "smooth";
            ele.scrollLeft += 220;
        }
    }

    function scrollRight() {
        var ele = document.getElementById("scrollContainter");
        if (ele) {
            ele.style.scrollBehavior = "smooth";
            ele.scrollLeft -= 220;
        }
    }


    return {

        oninit(vnode) {
            let maximumDays = 28;
            if(vnode.attrs.maximumDays){
                maximumDays = vnode.attrs.maximumDays;
            }
            for (let i = 0; i <= maximumDays; i++) {
                showDateList.push(dayjs().add(i, 'day').format("YYYY-MM-DD"))
            }

        },

        oncreate(vnode) {
            var scrollContainter = document.getElementById("scrollContainter");
            var selectedDate = document.getElementById("selectedDate");

            if (selectedDate) {
                selectedDate.scrollIntoView({ block: 'center', inline: 'center' });
            }

            var firstDate = document.querySelector('.firstDate');
            var lastDate = document.querySelector('.lastDate');

            if (scrollContainter && firstDate && lastDate) {

                let options = {
                    root: scrollContainter,
                    rootMargin: '0px',
                    threshold: 1.0
                }

                let callback = (entries, observer) => {
                    entries.forEach(entry => {

                        if (entry.target.classList.contains("firstDate")) {
                            previousBtnActiveStatus = !entry.isIntersecting;
                            m.redraw();

                        } else if (entry.target.classList.contains("lastDate")) {
                            nextBtnActiveStatus = !entry.isIntersecting;
                            m.redraw();
                        }

                    })
                }
                scrollContainter.onscroll = (event) => {
                    nextBtnActiveStatus = true;
                    previousBtnActiveStatus = true;
                };

                let observer = new IntersectionObserver(callback, options);
                observer.observe(firstDate);
                observer.observe(lastDate);

            }
        },

        view(vnode) {
            return [
                m("div", { class: "d-flex justify-content-between bg-white" }, [

                    m("div", { class: "d-flex text-center clickable" },
                        m("a", {
                            class: "btn btn-sm px-1 btn-link btn-block align-self-center text-center",
                            href: "#",
                            onclick: (event: Event) => {
                                event.preventDefault();
                                scrollRight();
                            }
                        },
                            m(CustomSvgIcon, {
                                iconType: 'keyboard_arrow_left',
                                themeCssClass: (previousBtnActiveStatus) ? "svg-info stroke-info svg-20px" : "svg-muted stroke-muted svg-20px"
                            })
                        )
                    ),

                    m("div", { class: "d-flex flex-grow-1 outer-group", id: "scrollContainter" },

                        m("div", { class: "d-flex flex-row flex-nowrap flex-grow-1", id: "scrollContent" },

                            showDateList.map(date => {
                                let selected: boolean = (dayjs(date).format("YYYY-MM-DD") == vnode.attrs.searchDate)
                                let primaryClass = "d-flex justify-content-center align-items-center flex-fill clickable py-1 px-2 "
                                let calssName = "";
                                if (date == showDateList[0]) {
                                    calssName = primaryClass + "firstDate";
                                } else if (date == showDateList[showDateList.length - 1]) {
                                    calssName = primaryClass + "lastDate";
                                } else {
                                    calssName = primaryClass;
                                }

                                return m("div", {
                                    class: calssName,
                                    id: (selected) ? "selectedDate" : "",

                                }, [
                                    m(DateButton, {
                                        isoDateString: dayjs(date).format("YYYY-MM-DD"),
                                        isSelected: selected,
                                        onClick: () => {
                                            if (dayjs(date).format("YYYY-MM-DD") >= dayjs(new Date).format('YYYY-MM-DD')) {
                                                vnode.attrs.onDateChange(vnode.attrs.searchCriteria.withDate(dayjs(date).format("YYYY-MM-DD")));
                                            }
                                        }
                                    }),
                                ]);
                            })
                        ),
                    ),

                    m("div", { class: "d-flex text-center clickable" },
                        m("a", {
                            class: "btn btn-sm px-1 btn-link btn-block align-self-center text-center", href: "#",
                            onclick: (event: Event) => {
                                event.preventDefault();
                                scrollLeft();
                            }
                        },

                            m(CustomSvgIcon, {
                                iconType: 'keyboard_arrow_right',
                                themeCssClass: (nextBtnActiveStatus) ? "svg-info stroke-info svg-20px" : "svg-muted stroke-muted svg-20px"
                            })
                        )
                    )
                ]),
            ]
        }
    }
}

var DateButton: m.Component<{ isoDateString: string, isSelected: boolean, onClick: Function }> = {
    view: function (vnode) {
        let primaryClass: string = "d-flex flex-column justify-content-center text-center "

        return m("div", {
            class: (vnode.attrs.isSelected) ? primaryClass + "bg-primary text-white " : primaryClass,
            style: (vnode.attrs.isSelected) ? "line-height: 16px; border-radius: 50%; width: 37px; height: 37px;" : "line-height: 16px; width: 37px; height: 37px;",

            onclick: (event: Event) => {
                event.preventDefault();
                vnode.attrs.onClick();
            }
        },
            [
                m("div", { class: (vnode.attrs.isSelected) ? "text-white" : "text-muted", style: "font-size:10px;" }, dayjs(vnode.attrs.isoDateString).format("ddd").toUpperCase()),
                m("div", { class: "font-weight-bold text-center", style: "font-size:medium;" }, dayjs(vnode.attrs.isoDateString).format("D")),

            ]
        )
    }
}

export default DateSwitcher;